<template>
  <div class="main">
    <keep-alive include="birthdaylist">
      <router-view v-if="userLoginFinish && $route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="userLoginFinish && !$route.meta.keepAlive"></router-view>

    <x-dialog v-model="tipDialog" class="dialog-pop" :scroll="false">
      <div class="content-wrap">
        <p v-html="tipText"></p>
      </div>
      <div class="btn-wraps">
        <a href="javascript:;" class="btn-txt" @click="tipDialog=false">{{tipBtnText}}</a>
      </div>
    </x-dialog>
    <!-- <div v-if="qyWxModal" class="qy-wx-modal">
        <div class="modal-content">
            <p class="title">发放关怀请前往管理后台</p>
            <p class="content">
            手机端仅支持员工查看关怀，登录企业微信管理后台进入应用管理端可以发放关怀。
            </p>
            <p class="tip">
            登录企业微信后台，请访问：
            https://work.weixin.qq.com/login
            </p>
            <button @click="qyWxModalConfirm">
            我知道了
            </button>
        </div>
        <div class="shadow-modal">
        </div>
    </div> -->
  </div>
</template>
<script>
  import Cookies from 'js-cookie'
import  XDialog  from 'vux/src/components/x-dialog/index.vue'
  import config from '../../config/config'
  import {httpGet, httpJsonp} from "../../api/base"
  import {
    mapGetters,
    mapActions,
    mapState
  } from 'vuex'

  export default {
    data() {
      return {
        tipDialog: false,
        tipText: '',
        tipBtnText: '知道啦',
        qyWxModal: false,
        id: '',
      }
    },
    components: {
      XDialog,
    },
    computed: {
      corpId() {
        return this.$route.query.corpId
      },
      ...mapGetters({
        // userInfo: 'userInfo',
        getUserInfo: 'getUserInfo',
        userLoginFinish: "userLoginFinish",
        getcorpId: 'getcorpId',
        corpCustomize:'getCorpCustomize',
      }),
      ...mapState({
          customizePageTitle(state){
            console.log('title', state.customize)
              return state.customize.page_title_default || state.customize.page_title || '乐关怀'
          }
      })
    },
    watch: {
      corpId(cval) {
        if (cval) {
          // this.$store.dispatch('userSectionCheck');
          // this.$store.dispatch('switchCompany',{corpId:cval})
        }
      },
      // userInfo(cval) {
      //   if (cval) {
      //     if (this.corpId && this.userInfo.loginUserInfo.gcorp_id != this.corpId) {
      //       this.$store.dispatch('switchCompany', {corpId: this.corpId})
      //     } else {
      //       this.$store.dispatch('userLoginFinish',{corpId: this.userInfo.loginUserInfo.gcorp_id});
      //       // this.$store.dispatch('showMergeNav');
      //     }
      //   }
      // },
      getUserInfo(cval) {
        if (cval) {
          if (this.corpId && this.getUserInfo.corpId != this.corpId) {
            this.$store.dispatch('switchCompany', {corpId: this.corpId})
          } else {
            
            this.$store.dispatch('userLoginFinish',{corpId: this.getUserInfo.corpId})
            this.$store.dispatch('getCorpCustomize').then(()=>{
                
            })
            // this.$store.dispatch('showMergeNav');
          }
        }
      },
      getcorpId: {
        handler: function (val, oldVal) {
          if (typeof val != 'number') {
            this.showMsg(val)
          }
        },
        deep: true
      },
      $route(to, from) {
        this.checkUserInfo();
      },
      customizePageTitle(val){
          if(val){
              document.title = val;
              if (window.AlipayJSBridge) {
                AlipayJSBridge.call('setTitle', { title: val });
              }
          }
      },
      corpCustomize(val){
        if(val && !val.page_title){
          let default_title = '乐关怀';
          document.title = default_title;
          if (window.AlipayJSBridge) {
            AlipayJSBridge.call('setTitle', { title: default_title });
          }
        }
      }
    },
    created() {
      let _this = this;
      //检查用户是否登录
      this.checkUserInfo();
      if (Cookies.get('auth_user_welcome')) {
        this.qyWxModal = true;
        this.id = Cookies.get('auth_user_welcome')
        document.body.addEventListener('touchmove', _this.preHandler, false);
        document.addEventListener('AlipayJSBridgeReady',  _this.preHandler, false);
      }
      
    },
    methods: {
      preHandler(e) {
        e.preventDefault()
      },
      qyWxModalConfirm() {
        let _this = this
        httpJsonp(config.qy_wx_weuit + 'wesuit/api/v1/corp/updateAuthUserWelcomeById', {id: this.id}, (error, res) => {
          console.log('res', res)
          if (res && res.errno == 0) {
            document.body.removeEventListener('touchmove', _this.preHandler, false);
            let hostArr = window.location.hostname.split('.')
            let domain = hostArr[hostArr.length - 2] + '.' + hostArr[hostArr.length - 1];
            Cookies.remove('auth_user_welcome', {domain: domain})
            console.log('cookes', Cookies.get('auth_user_welcome'))
            this.qyWxModal = false;
          }
        })
      },
      showMsg(txt, btntxt) {
        this.tipText = txt;
        if (btntxt) {
          this.tipBtnText = btntxt;
        }
        this.tipDialog = true;
      },
      checkUserInfo(){
        if(this.$route.name != 'ServiceForbidden'){
          // this.$store.dispatch('getUserinfo');
          this.$store.dispatch('loadUserInfo');
        } else {
          this.$store.dispatch('userLoginFinish', {corpId: -999});
        }
      }
    },
    mounted() {
      this.$store.dispatch('loadIsWxWorkAgent')
      window.HTTPSTATUS.$on('HTTPSCODE', (val) => {
        if (val.code == 500) {
          this.showMsg(val.msg, '好的')
        } else {
          this.showMsg(val.msg)
        }
      })
    }
  }
</script>